import { Component, Input } from '@angular/core';
import { DataServiceService } from '../../services/data-service.service';
import { MessageService } from 'primeng/api';
import { DateTime } from 'luxon';
import { DriverCard, Drivers, Orders } from '../../interfaces';

@Component({
  selector: 'app-time-edit-dialog',
  templateUrl: './time-edit-dialog.component.html',
  styleUrl: './time-edit-dialog.component.scss'
})
export class TimeEditDialogComponent {

constructor(private dataServiceService: DataServiceService, private messageService: MessageService) {}

@Input() selectedOrder!: Orders;
@Input() selectedDriverDispatch!: number;
@Input() drivers!: Drivers[];
@Input() orders!: Orders[];
@Input() selectedDate!: Date | null;

showEditTimeDialog = false
editTimeType: 'pickup' | 'delivery' = 'delivery';

editTime(driverId: number, orderId: number, type: 'pickup' | 'delivery' = 'delivery') {
  console.log(driverId, orderId, type);
  this.selectedDriverDispatch = driverId;
  this.selectedOrder = this.orders.find(order => order.order_id === orderId) || {} as Orders;
  this.editTimeType = type;
  
  // Set the current date/time for the selected type, converting from UTC to Central time
  if (type === 'pickup' && this.selectedOrder?.pickup_date) {
    // Convert UTC date to Central time for display
    const utcDate = DateTime.fromISO(this.selectedOrder.pickup_date.toString(), { zone: 'utc' });
    const centralDate = utcDate.setZone('America/Chicago');
    this.selectedDate = centralDate.toJSDate();
  } else if (type === 'delivery' && this.selectedOrder?.delivery_date) {
    // Convert UTC date to Central time for display
    const utcDate = DateTime.fromISO(this.selectedOrder.delivery_date.toString(), { zone: 'utc' });
    const centralDate = utcDate.setZone('America/Chicago');
    this.selectedDate = centralDate.toJSDate();
  } else {
    // Default to current Central time
    const centralNow = DateTime.now().setZone('America/Chicago');
    this.selectedDate = centralNow.toJSDate();
  }
  
  this.showEditTimeDialog = true;
}


saveEditTime(type: string) {
  if (!this.selectedOrder || !this.selectedDate) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Please select a valid date and time'
    });
    return;
  }

  const previousValue = type === 'delivery' ? this.selectedOrder.delivery_date : this.selectedOrder.pickup_date;
  
  // Convert the Central time back to UTC for database storage
  const centralDate = DateTime.fromJSDate(this.selectedDate!, { zone: 'America/Chicago' });
  const utcDate = centralDate.setZone('utc').toISO();
  
  if (type === 'delivery') {
    this.selectedOrder.delivery_date = utcDate as any;
  } else if (type === 'pickup') {
    this.selectedOrder.pickup_date = utcDate as any;
  }
  
  this.dataServiceService.updateOrder(this.selectedOrder.order_id, this.selectedOrder).subscribe({
    next: (data) => {
      this.showEditTimeDialog = false;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `${type === 'delivery' ? 'Delivery' : 'Pickup'} time updated successfully`
      });
      
      // Refresh the driver cards to show updated times
      // The data will automatically refresh through the selectedDate$ subscription
    },
    error: (error) => {
      // Revert the change on error
      if (type === 'delivery') {
        this.selectedOrder.delivery_date = previousValue;
      } else if (type === 'pickup') {
        this.selectedOrder.pickup_date = previousValue;
      }
      
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to update time. Please try again.'
      });
      console.error('Failed to update order time:', error);
    }
  });
}
}
